import request from "../../utils/useApi";

const REDIRECT_FALLBACK_CODES = new Set([
  "auth/popup-blocked",
  "auth/cancelled-popup-request",
  "auth/operation-not-supported-in-this-environment",
]);

export const shouldFallbackToGoogleRedirect = (error) =>
  REDIRECT_FALLBACK_CODES.has(error?.code);

export async function exchangeGoogleSession(user) {
  if (!user?.getIdToken) {
    throw new Error("Google did not return a valid user session.");
  }

  const firebaseIdToken = await user.getIdToken(true);
  const response = await request.post("/auth/loginWithSocialV2", {}, {
    headers: {
      Authorization: `Bearer ${firebaseIdToken}`,
    },
  });
  const session = response?.data?.data;

  if (response?.status !== 200 || !session?.token || !session?.user?._id) {
    throw new Error(
      response?.data?.message ||
      "Google sign-in could not create a Teleport Now session."
    );
  }

  return session;
}
